import * as React from "react";
import { Divider } from 'antd';
import { formatDate } from 'src/util/Date.helper';
import { MoneyMask } from 'src/util/Masks/MoneyMask';
import { useState, useEffect, useContext } from 'react';
import { ServiceContext } from 'src/services/provider/Service.provider';
import { ISelectBankList } from 'src/services/interfaces/ISelectBankList';
import { IBankOwner } from 'src/services/interfaces/trade/tradeOwner/IBankOwner';
import { IUser } from 'src/services/interfaces/UserInterface';

interface IExpenseInfoProps {
  bankData: IBankOwner;
  maturityDate: Date;
  invoiceNumber: string;
  totalValue: number;
  approvalUser?: IUser;
}

export const ExpenseInfo: React.FC<IExpenseInfoProps> = ({ bankData, maturityDate, invoiceNumber, totalValue, approvalUser }) => {
  const { commonDomainService } = useContext(ServiceContext);

  const moneyMask = ({ value }) => MoneyMask(value!);
  const [selectList, setSelectList] = useState<ISelectBankList[]>([]);

  useEffect(() => {
    loadBankList();
  }, []);

  function loadBankList() {
    commonDomainService.getBankList().then(resp => {
      setSelectList(resp.bank_configuration_json);
    });
  }

  return (
    <div className="region-container client-info">
      <span className="subtitle">Informações da solicitação de pagamento</span>
      <div>
        <div className="row">
          <span className="left description">N° NF/ND:</span>
          <span className="right description">{invoiceNumber}</span>
        </div>
        <div className="row">
          <span className="left description">Valor total da NF/ND:</span>
          <span className="right description">{moneyMask({ value: totalValue })}</span>
        </div>
        <div className="row">
          <span className="left description">Data de Vencimento:</span>
          <span className="right description">{formatDate(maturityDate)}</span>
        </div>
        {approvalUser?.fullName &&
          <div className="row">
            <span className="left description">Responsável pela aprovação:</span>
            <span className="right description">{approvalUser?.fullName}</span>
          </div>
        }
        <Divider orientation="left" style={{ whiteSpace: 'nowrap', background: 'transparent', color: 'rgba(0, 0, 0, 0.85)', marginTop: "8px", marginBottom: "8px" }}>
          Dados bancários
        </Divider>
        <div className="row">
          <span className="left description">Banco:</span>
          {selectList.length > 0 && <span className="right description">{`${bankData.bank} - ${selectList.filter(o => o.code === bankData.bank)[0]?.name}`}</span>}
        </div>
        <div className="row">
          <span className="left description">Agência:</span>
          <span className="right description">{bankData.agency}</span>
        </div>
        <div className="row">
          <span className="left description">Tipo de Conta:</span>
          <span className="right description">{bankData.accountType}</span>
        </div>
        <div className="row">
          <span className="left description">Conta:</span>
          <span className="right description">
            {bankData.accountDigit ? `${bankData.account}-${bankData.accountDigit}` : bankData.account}
          </span>
        </div>
      </div>
    </div>
  );
};


// WEBPACK FOOTER //
// ./src/components/common/ExpenseList/Details/ExpenseInfo/ExpenseInfo.tsx